module.exports = __webpack_public_path__ + "static/media/Jake.cebb42ed.jpg";